import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../api';
import '../../styles/AdminLogin.css';

function AdminLoginPage() {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Credenciais do super admin (MUDE A SENHA!)
  const ADMIN_CREDENTIALS = {
    username: 'supportAdmin',
    password: 'Admin@2024!Secur', // ⚠️ MUDE ISSO!
    role: 'superadmin'
  };

  // Verificar se já está logado
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');

    if (token && adminData) {
      try {
        const parsed = JSON.parse(adminData);
        if (parsed.username === 'supportAdmin' && parsed.role === 'superadmin') {
          navigate('/admin');
        }
      } catch (error) {
        console.error('Erro ao verificar sessão:', error);
      }
    }
  }, [navigate]);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simular delay de autenticação
    await new Promise(resolve => setTimeout(resolve, 800));

    // Verificar credenciais
    if (
      credentials.username === ADMIN_CREDENTIALS.username &&
      credentials.password === ADMIN_CREDENTIALS.password
    ) {
      try {
        // Obter token do backend
        const { token } = await authAPI.getAdminToken();

        // Criar dados do admin
        const adminData = {
          username: ADMIN_CREDENTIALS.username,
          role: ADMIN_CREDENTIALS.role,
          loginTime: new Date().toISOString()
        };

        // Salvar no localStorage
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminData', JSON.stringify(adminData));

        // Redirecionar
        navigate('/admin');
      } catch (apiError) {
        console.error('Erro ao obter token de admin:', apiError);
        setError('Falha ao autenticar com o servidor. Verifique o backend.');
        setLoading(false);
      }
    } else {
      setError('Usuário ou senha inválidos');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <div className="admin-icon">🔐</div>
          <h1>Painel Administrativo</h1>
          <p className="admin-subtitle">Gabrielly Semijoias</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="username">
              <span className="label-icon">👤</span>
              Usuário
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              placeholder="Digite seu usuário"
              required
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <span className="label-icon">🔑</span>
              Senha
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Digite sua senha"
              required
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Autenticando...
              </>
            ) : (
              <>
                <span className="button-icon">🚀</span>
                Entrar
              </>
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <button
            onClick={() => navigate('/')}
            className="back-button"
            type="button"
          >
            ← Voltar ao site
          </button>
        </div>

        <div className="security-notice">
          <span className="notice-icon">🛡️</span>
          <small>Acesso restrito apenas para administradores autorizados</small>
        </div>
      </div>
    </div>
  );
}

export default AdminLoginPage;